<template>
  <div>
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>
    <div class="area_title">
      <h1>{{ productCenterPage.title }}</h1>
      <div class="breadcrumb_wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ navbar.home }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/prod_center' }" replace>{{ productCenterPage.title }}</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="search-nav">
          <el-input
          v-model="searchKeywords"
          :placeholder="productCenterPage.searchPlaceholder">
            <template slot="append">
              <el-button size="mini" class="el-icon-search" style="color: #333;" @click="handleSearch">
              </el-button>
            </template>
          </el-input>
          <!-- <div class="search-nav__tip">
            <i class="el-icon-info"></i>
            <span>{{ productCenterPage.searchTip }}</span>
          </div> -->
        </div>
      </div>
    </div>
    <!-- <div class="area_cation">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in nameList"
          :label="item.cate_name"
          :name="index + ''"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
    </div> -->
      <div class="product_wrap1">
        <span class="product_title">{{ productCenterPage.subTitle }}</span>
        <span class="product_content"
          >{{detailsInfo[`${currentLang.prefix}summary`]}}</span
        >
      </div>
      <div class="product_wrap2" v-for="(item, index) in appList" :key="index">
        
        <div class="product_block" v-if="index%2 === 0">
          <img
            :src="item.full_image"
            alt=""
            class="product_img"
          />
          <div class="product_details">
            <div class="details_title">{{item[`${currentLang.prefix}cate_name`]}}</div>
            <div class="details_dest">
              {{item[`${currentLang.prefix}summary`]}}
            </div>
            <ul>
              <li v-for="(item1, index1) in item.cate_list" :key="index1" @click="goList(index,item.id,item1.id)">
                <div class="details_name">
                  <span></span>
                  {{item1[`${currentLang.prefix}cate_name`]}}
                </div>
                <span class="el-icon-arrow-right"></span>
              </li>
            </ul>
            <div class="more_btn" @click="goList(index,item.id)">
              <span>MORE</span>
              <img src="../../../assets/images/public/arrow1.png" alt="" />
            </div>
          </div>
        </div>
        <div class="product_block" v-if="index%2 === 1">
          <div class="product_details">
            <div class="details_title">{{item[`${currentLang.prefix}cate_name`]}}</div>
            <div class="details_dest">
              {{item[`${currentLang.prefix}summary`]}}
            </div>
            <ul>
              <li v-for="(item1, index1) in item.cate_list" :key="index1" @click="goList(index,item.id,item1.id)">
                <div class="details_name">
                  <span></span>
                  {{item1[`${currentLang.prefix}cate_name`]}}
                </div>
                <span class="el-icon-arrow-right"></span>
              </li>
              
            </ul>
            <div class="more_btn" @click="goList(index,item.id)">
              <span>MORE</span>
              <img src="../../../assets/images/public/arrow1.png" alt="" />
            </div>
          </div>
          <img
          :src="item.full_image"
            alt=""
            class="product_img"
          />
        </div>
      </div>
      
    <footer-wrap></footer-wrap>

    <feedback-popup></feedback-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getCateListProduct,getCateDetailInfo } from "@/utils/http.js";
import FeedbackPopup from './modules/feedbackPopup.vue';

export default {
  components: {
    FeedbackPopup
  },

  data() {
    return {
      appList:[],
      detailsInfo:{},

      searchKeywords: ''
    };
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    productCenterPage() {
      return this.currentLang.config.productCenterPage
    },
    navbar() {
      return this.currentLang.config.navbar
    },
  },

  created() {},
  mounted() {
    this.getProductNameList();
    this.getDetails()
  },
  methods: {
    handleSearch() {
      this.$router.push({
        path: '/prod_search_list',
        query: {
          keywords: this.searchKeywords,
          index: 0,
          parentId: 42,
          from: 'prod_center'
        }
      })
    },
   
    getProductNameList() {
      getCateListProduct().then(res => {
        console.log(res);
        if (res.code === 1) {
          this.appList = res.data
          // res.data.forEach(item => {
          //   this.nameList.push(item);
          // });
        }
      });
    },
    getDetails() {
      getCateDetailInfo({ cate_id: 41 }).then(res => {
        console.log(res);
        if (res.code === 1) {
          this.detailsInfo = res.data;
        }
      });
    },
    goList(index,id,sonId){
      console.log(index,id,sonId)
      this.$router.push({ path: "/prod_list", query: {index:index,parentId:id,sonId: sonId} })
    }
  }
};
</script>

<style scoped lang="scss">
.area_title {
  width: 100%;
  height: 160px;
  line-height: 160px;
  background: url("../../../assets/images/public/i12.jpg") no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center center;
  text-align: center;
  position: relative;
  h1 {
    color: white;
    font-weight: normal;
  }
  .breadcrumb_wrap {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    position: absolute;
    top: 15px;
    left: calc(50% - 600px);
    /deep/ .el-breadcrumb__item {
      span {
        color: #fff;
        font-size: 16px;
        font-weight: normal;
      }
    }

    .search-nav {
      line-height: 1.5;
    }

    .search-nav__tip {
      margin-top: 6px;
      text-align: left;
      font-size: 13px;
      font-weight: 300;
      color: rgba(255, 255, 255, 0.8);
    }

    /deep/ .el-input__inner {
      height: 36px;
      line-height: 36px;
      border: none;
      outline: none;
    }
  }
}
.area_cation {
  display: flex;
  justify-content: center;
  /deep/ .el-tabs {
    width: 100%;
    .el-tabs__header {
      height: 60px;
      line-height: 60px;
      background: #4b4b4b;
      border: 0;
      // width: 1200px;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-tabs__nav-wrap {
        height: 100%;
        margin-bottom: 0;
        .el-tabs__nav-scroll {
          height: 100%;
          .el-tabs__nav {
            height: 100%;
            border: 0;
            .el-tabs__item {
              height: 100%;
              color: #979797;
              border-left: none;
              border-bottom: none;
              padding: 0 25px;
              line-height: unset;
              font-size: 16px;
            }
            .is-active {
              background: #646464;
            }
          }
        }
      }
    }
  }
}
.product_wrap1 {
  width: 1200px;
  padding: 60px 0;
  margin: 0 auto;
  text-align: center;
  .product_title {
    width: 100%;
    font-size: 30px;
    display: block;
    color: #323232;
  }
  .product_content {
    width: 100%;
    height: auto;
    margin-top: 40px;
    font-size: 18px;
    text-align: justify;
    text-align-last: center;
    line-height: 1.8;
    color: #777;
    display: block;
  }
}
.product_wrap2 {
  width: 100%;
  height: auto;
  padding: 35px 0;
  border-top: 1px solid #dbdbdb;
  .product_block {
    width: 1200px;
    height: auto;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .product_img {
      width: 500px;
      height: auto;
    }
    .product_details {
      width: 470px;
      height: auto;
      .details_title {
        font-size: 28px;
        color: #003359;
      }
      .details_dest {
        padding: 35px 0;
        font-size: 18px;
        line-height: 1.8;
        color: #555;
        border-bottom: 1px solid #5c5c5c;
        text-align: justify;
      }
      ul {
        li {
          width: calc(100% - 30px);
          height: 45px;
          border-bottom: 1px solid #acacac;

          color: #555;
          padding: 0 15px;
          line-height: 45px;
          font-size: 18px;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .details_name {
            display: flex;
            align-items: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
              
            span {
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background: #555;
              display: block;
              margin-right: 10px;
              
            }
          }
        }
      }
      .more_btn {
        width: 130px;
        height: 40px;
        background: #e5363e;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        margin: 50px 0 15px;
        cursor: pointer;
        img{
          width: 40px;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home_product_center/index.vue